<template>
  <div
    class="base-vimeo-video"
    :class="{ 'base-vimeo-video--landscape': !isBroken }"
  >
    <video
      :src="videoSrc"
      :poster="videoPoster"
      :autoplay="videoAutoplay"
      :muted="videoMuted"
      :loop="videoLoop"
      preload="none"
      playsinline=""
    />
  </div>
</template>

<script>
import windowResizeMixin from '../mixins/windowResizeMixin';

export default {
  name: 'BaseVimeoVideo',

  mixins: [windowResizeMixin],

  props: {
    videoBreakpoint: {
      type: Number,
      default: 0,
    },
    videoMobile: {
      type: String,
      default: null,
    },
    videoDesktop: {
      type: String,
      default: null,
    },
    videoPosterMobile: {
      type: String,
      default: null,
    },
    videoPosterDesktop: {
      type: String,
      default: null,
    },
    videoAutoplay: {
      type: Boolean,
      default: false,
    },
    videoMuted: {
      type: Boolean,
      default: false,
    },
    videoLoop: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      videoSrc: '',
      videoPoster: '',
    };
  },

  computed: {
    isBroken() {
      return this.$windowWidth < this.videoBreakpoint;
    },
  },

  watch: {
    $windowWidth() {
      this.setData();
    },
  },

  mounted() {
    this.setData();
  },

  methods: {
    setData() {
      this.videoSrc = this.isBroken ? this.videoMobile : this.videoDesktop;
      this.videoPoster = this.isBroken
        ? this.videoPosterMobile
        : this.videoPosterDesktop;
    },
  },
};
</script>
